import { Fragment } from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { StyledTitle } from 'components/StyledTitle';

const { Text } = Typography;

interface BankTransferInformationProps {
  beneficiaryName: string;
  beneficiaryBankName: string;
  bankAddress: string;
  swiftCode: string;
  bankCode: string;
  branchCode: string;
  bankAccountNumber: string;
}

export const BankTransferInformation = ({
  beneficiaryName,
  beneficiaryBankName,
  bankAddress,
  swiftCode,
  bankCode,
  branchCode,
  bankAccountNumber,
}: BankTransferInformationProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      {[
        {
          title: 'shortfallPayment.bankTransfer.beneficiaryName',
          value: beneficiaryName,
          testID: 'beneficiaryName',
        },
        {
          title: 'shortfallPayment.bankTransfer.beneficiaryBankName',
          value: beneficiaryBankName,
          testID: 'beneficiaryBankName',
        },
        {
          title: 'shortfallPayment.bankTransfer.bankAddress',
          value: bankAddress,
          testID: 'bankAddress',
        },
        { title: 'shortfallPayment.bankTransfer.swiftCode', value: swiftCode, testID: 'swiftCode' },
        { title: 'shortfallPayment.bankTransfer.bankCode', value: bankCode, testID: 'bankCode' },
        { title: 'shortfallPayment.bankTransfer.branchCode', value: branchCode, testID: 'branchCode' },
        {
          title: 'shortfallPayment.bankTransfer.bankAccountNumber',
          value: bankAccountNumber,
          testID: 'bankAccountNumber',
        },
      ].map(({ title, value, testID }) => (
        <Fragment key={testID}>
          <Text type="secondary">{t(title)}</Text>
          <StyledTitle level={5}>{value}</StyledTitle>
          <br />
        </Fragment>
      ))}
    </>
  );
};
